import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { openModalAdvice } from '../../utils/modals';

const Notifications = ({ config, onAnalize, onClose, onSaveVariable }) => {
  const [notificationAccepted, setNotificationAccepted] = useState({ item: {}, confirm: false });

  useEffect(() => {
    if (notificationAccepted.confirm) {
      onSaveVariable(notificationAccepted.item.variable);
    }
    onClose(notificationAccepted.item);
  }, [notificationAccepted]);

  useEffect(() => {
    if (!window?.IS_RUNNING_IN_CYPRESS) {
      for (const item of config) {
        if (onAnalize(item)) {
          const { title, children, customButtons } = item;

          openModalAdvice({
            title,
            children,
            close: () => onClose(item),
            customButtons,
            accept: () => setNotificationAccepted({ item, confirm: true }),
          });
        }
      }
    }
  }, [onAnalize]);
};

export default Notifications;

Notifications.propTypes = {
  config: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.title,
      children: PropTypes.element,
      customButtons: PropTypes.bool,
    }),
  ).isRequired,
  onAnalize: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaveVariable: PropTypes.func.isRequired,
};
